import {
  Box,
  Button,
  Center,
  CircularProgress,
  Container,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spinner,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useToast,
} from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { CustomSelect } from "../../customComponents/components";
import { FuncButton } from "../../customComponents/components/FuncButton";
import { PageHead } from "../../home/components/PageHead";
import { TableHead } from "../../home/components/TableHead";
import { useVehicleList } from "../../vehicle/hooks";
import { head } from "../helpers";
import {
  useVehicleMarkDelete,
  useVehicleMarkList,
  useVehicleMarkSet,
} from "../hooks";

export const VehicleStockListScreen = () => {
  const [activeMarkId, setActiveMarkId] = useState(null);
  const { vehiclesList, vehicleLoading } = useVehicleList();
  const [selectedVehicleId, setSelectedVehicleId] = useState(null);
  const toast = useToast();
  const labelRef = useRef<HTMLInputElement>();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const { vehicleMarkListLoading, vehicleMarkList, getVehicleMarkList } =
    useVehicleMarkList();
  const { vehicleMarkSetLoading, getVehicleMarkSet } = useVehicleMarkSet();
  const { vehicleMarkDeleteReq, vehicleMarkDeleteLoading } =
    useVehicleMarkDelete();

  useEffect(() => {
    getVehicleMarkList();
  }, []);

  const loading =
    vehicleMarkListLoading || vehicleMarkSetLoading || vehicleMarkDeleteLoading;

  const onClose = () => setModalIsOpen(false);

  const onSubmit = async () => {
    if (selectedVehicleId) {
      const res = await getVehicleMarkSet({ vehicle_id: selectedVehicleId });
      if (res.data.success) {
        toast({
          title: "Успешно добавлено",
          status: "success",
          duration: 9000,
          isClosable: true,
        });
      }
      getVehicleMarkList();
      setModalIsOpen(false);
    }
  };

  return (
    <>
      <PageHead
        breadCrumbs={<Heading>Список авто с акциями</Heading>}
        onClick={() => {
          setActiveMarkId(null);
          setModalIsOpen(true);
        }}
        linkLabel="Добавить автомобиль в акции"
      >
        {loading || vehicleLoading ? (
          <Container height="calc(100vh - 240px)">
            <Spinner position={"absolute"} top="50%" right="50%" size="xl" />
          </Container>
        ) : (
          <TableHead column={head}>
            {vehicleMarkList.map(({ id, title }) => (
              <Tr key={id}>
                <Td>
                  <Text fontSize="sm" color="#121419">
                    {id}
                  </Text>
                </Td>
                <Td>
                  <Text fontSize="sm" color="#121419">
                    {title}
                  </Text>
                </Td>
                <Td isNumeric>
                  <Button
                    marginLeft={"20px"}
                    colorScheme="red"
                    onClick={() => {
                      if (window.confirm("Пожалуйста, подтвердите удаление")) {
                        vehicleMarkDeleteReq({ id }).then(() => {
                          getVehicleMarkList();
                        });
                      }
                    }}
                  >
                    Удалить
                  </Button>
                </Td>
              </Tr>
            ))}
          </TableHead>
        )}
      </PageHead>
      <Modal isOpen={modalIsOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Добавить автомобиль в акции</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {loading ? (
              <Center>
                <CircularProgress isIndeterminate />
              </Center>
            ) : (
              <FormControl>
                <FormLabel>Выберите автомобиль</FormLabel>
                <CustomSelect
                  options={vehiclesList}
                  meta={{}}
                  onChangeVehicleId={setSelectedVehicleId}
                />
              </FormControl>
            )}
          </ModalBody>

          <ModalFooter>
            <Button variant="ghost" onClick={onClose}>
              Отменить
            </Button>
            <Button
              disabled={loading}
              colorScheme="blue"
              mr={3}
              onClick={onSubmit}
              marginLeft="20px"
            >
              {activeMarkId ? "Редактировать" : "Создать"}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
